import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GeotabPageNotAccessibleComponent } from './components/geotab-page-not-accessible/geotab-page-not-accessible.component';

const routes: Routes = [
  {
    path: 'page-not-accessible',
    component: GeotabPageNotAccessibleComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeotabRoutingModule {}
